/**
 * @file Metadata suggestions supported extensions
 * @author Box
 */

const SUPPORTED_FILE_EXTENSIONS = new Set([
    // Text-Based Documents
    'as',
    'as3',
    'asm',
    'bat',
    'c',
    'cc',
    'cmake',
    'cpp',
    'cs',
    'css',
    'csv',
    'cxx',
    'diff',
    'doc',
    'docx',
    'erb',
    'gdoc',
    'groovy',
    'gsheet',
    'h',
    'haml',
    'hh',
    'htm',
    'html',
    'java',
    'js',
    'json',
    'less',
    'log',
    'm',
    'make',
    'md',
    'ml',
    'mm',
    'msg',
    'ods',
    'odt',
    'pages',
    'pdf',
    'php',
    'pl',
    'properties',
    'py',
    'rb',
    'rst',
    'rtf',
    'sass',
    'scala',
    'scm',
    'script',
    'sh',
    'sml',
    'sql',
    'txt',
    'vi',
    'vim',
    'webdoc',
    'wpd',
    'xhtml',
    'xls',
    'xlsb',
    'xlsm',
    'xlsx',
    'xml',
    'xsd',
    'xsl',
    'xbd',
    'xdw',
    'yaml',
    // Presentations
    'gslide',
    'gslides',
    'key',
    'odp',
    'ppt',
    'pptx',
]);

export function isExtensionSupportedForMetadataSuggestions(extension: string): boolean {
    return SUPPORTED_FILE_EXTENSIONS.has(extension);
}
